// ------------------------------------
// Constants
// ------------------------------------

const SHOW_ERROR = 'SHOW_ERROR'
const REMOVE_ERROR = 'REMOVE_ERROR'

// ------------------------------------
// Actions
// ------------------------------------

export function showError(payload) {
  return {
    type: SHOW_ERROR,
    payload
  }
}

export function removeError() {
  return {
    type: REMOVE_ERROR
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  message: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_ERROR: {
      return {
        message: action.payload
      }
    }
    case REMOVE_ERROR: {
      return {
        message: null
      }
    }
  }
  return state
}
